import React from "react";
import { Link } from "react-router-dom";
import LegalPageBanner from "./LegalPageBanner";

const LINKS = [
  { to: "/Methodology", label: "Methodology" },
  { to: "/RiskDisclaimer", label: "Risk Disclaimer" },
  { to: "/PrivacyPolicy", label: "Privacy Policy" },
  { to: "/TermsAndConditions", label: "Terms & Conditions" },
  { to: "/RefundPolicy", label: "Refund Policy" },
];

function LegalNavPills() {
  return (
    <nav
      aria-label="Legal documents"
      className="flex flex-wrap items-center justify-center gap-2 sm:gap-3"
    >
      {LINKS.map(({ to, label }) => (
        <Link
          key={to}
          to={to}
          className="shrink-0 rounded-xl border border-white/25 bg-white/5 px-3 py-2 text-center text-xs font-semibold text-white transition hover:bg-white/10 sm:px-4 sm:text-sm"
        >
          {label}
        </Link>
      ))}
    </nav>
  );
}

/**
 * "Legal Informations" banner + legal nav pills; same width as the button row.
 * Single module (no separate LegalFooterNavLinks) to avoid import/compile issues.
 */
export default function LegalFooterBannerAndLinks() {
  return (
    <div className="mt-6 flex w-full min-w-0 justify-center">
      <div className="flex w-fit max-w-full min-w-0 flex-col items-stretch gap-4">
        <LegalPageBanner />
        <LegalNavPills />
      </div>
    </div>
  );
}
